<script lang="ts">
	import Carousel from "@components/common/Carousel.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Icon from "@components/common/Icon.svelte";
	import type { EmblaCarouselType } from "embla-carousel";
	import type { ClassValue } from "svelte/elements";
	import arrowIcon from "@core/assets/icons/arrow.svg?raw";
	import TeamMemberCard from "./TeamMemberCard.svelte";
	import { type TeamMember, teamMembers } from "./team.js";

	let canNext = $state(false);
	let canPrev = $state(false);

	let api = $state<EmblaCarouselType>();

	const {
		class: customClass,
		title,
	}: {
		class: ClassValue;
		title: string;
	} = $props();
</script>

<section class={["py-14 sm:py-17 md:py-20 lg:py-23 xl:py-26 full-width grid-container", customClass]}>
	<div class="flex justify-between mb-9 md:mb-15 items-center">
		<Heading level={2} class=" text-fcrdarkgray heading-2" text={title} />
		<div class={["hidden gap-2 text-fcrdarkgray", (canNext || canPrev) && "lg:flex"]}>
			<button
				type="button"
				class={[
					"size-16 flex items-center bg-white justify-center border-fcrlightgray-300 disabled:opacity-50 border rounded-full",
					"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
					"[&:not(:disabled):hover]:border-fcrdarkgray",
				]}
				onclick={(): void => {
					api?.scrollPrev();
				}}
				disabled={!canPrev}
			>
				<Icon icon={arrowIcon} class="size-4.5 rotate-180" />
			</button>
			<button
				type="button"
				class={[
					"size-16 flex items-center bg-white justify-center border-fcrlightgray-300 disabled:opacity-50 border rounded-full",
					"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
					"[&:not(:disabled):hover]:border-fcrdarkgray",
				]}
				onclick={(): void => {
					api?.scrollNext();
				}}
				disabled={!canNext}
			>
				<Icon icon={arrowIcon} class="size-4.5 " />
			</button>
		</div>
	</div>
	<Carousel
		bind:canNext
		bind:canPrev
		bind:api
		items={Object.values(teamMembers)}
		class="full-width"
		alignWithGridContainer
		itemsContainerClass="gap-4"
		options={{ dragFree: true }}
	>
		{#snippet item(teamMember: TeamMember)}
			<TeamMemberCard {teamMember} />
		{/snippet}
	</Carousel>
</section>
